import type { LngLatEntity } from '@/shared/entities/LngLatEntity'

export class MealAddressEntity {
  id?: string
  branchId?: number
  branchName?: string | null
  location?: LngLatEntity
  addressName?: string | null
  createdAt?: string
}
